import React from 'react';
import { SmallUpdateInfoWrapper, UpdateInfoWrapper } from '../../pages/tank-cleaning/TankCleaning.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { prettifyDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';

type Props = {
    inline?: boolean;
    createdUtc?: Date | string | null;
    createdBy?: string | null;
    lastUpdatedUtc?: Date | string | null;
    lastUpdatedBy?: string | null;
};

const UpdateInfoComponent: React.FC<Props> = (props) => {
    return (
        <>
            {!props.inline && (
                <UpdateInfoWrapper>
                    {props.createdUtc && (
                        <>
                            <h4>Created</h4>
                            <div>
                                <FontAwesomeIcon
                                    className="clock-icon"
                                    icon="clock"
                                    title={'Order created ' + prettifyDateTimeHHmm(props.createdUtc)}
                                />
                                <span>{prettifyDateTimeHHmm(props?.createdUtc)}</span>
                            </div>
                            <div>
                                <FontAwesomeIcon className="profile-icon" icon="user" title={'Order created by ' + props.createdBy} />
                                <span>{props?.createdBy}</span>
                            </div>
                        </>
                    )}
                    {props.lastUpdatedUtc && (
                        <>
                            <h4>Last updated</h4>
                            <div>
                                <FontAwesomeIcon
                                    className="clock-icon"
                                    icon="clock"
                                    title={'Last update ' + prettifyDateTimeHHmm(props.lastUpdatedUtc)}
                                />
                                <span>{prettifyDateTimeHHmm(props?.lastUpdatedUtc)}</span>
                            </div>
                            <div>
                                <FontAwesomeIcon className="profile-icon" icon="user" title={'Last update by ' + props.lastUpdatedBy} />
                                <span>{props?.lastUpdatedBy}</span>
                            </div>
                        </>
                    )}
                </UpdateInfoWrapper>
            )}

            {props.inline && (
                <SmallUpdateInfoWrapper>
                    {props.createdUtc && (
                        <>
                            <div>
                                <span>Created {prettifyDateTimeHHmm(props?.createdUtc)},</span>
                                <span> by </span>
                                <span>{props?.createdBy}</span>
                            </div>
                        </>
                    )}
                    {props.lastUpdatedUtc && (
                        <>
                            <div>
                                <span>Updated {prettifyDateTimeHHmm(props?.lastUpdatedUtc)},</span>
                                <span> by </span>
                                <span>{props?.lastUpdatedBy}</span>
                            </div>
                        </>
                    )}
                </SmallUpdateInfoWrapper>
            )}
        </>
    );
};

export default UpdateInfoComponent;
